import {FC} from "react";
import {Box} from "@mui/system";
// import logo2 from "../../../images/logo2.png";
// import {useTranslation} from "react-i18next";

export const SponsorComponent: FC = () => {
  // const {t} = useTranslation();

  return (
    <Box justifyContent={"center"} alignItems={"center"} display={"flex"} flexDirection={"column"} mb={2}>
      {/*<Box sx={{display: "flex", justifyContent: "center", alignItems: "center", gap:2}}>*/}
      {/*  <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection:"column", gap: 1}}>*/}
      {/*    <img height={55} src={logo2} alt={t('logo') || ""}/>*/}
      {/*  </Box>*/}
      {/*</Box>*/}
    </Box>)
}